import React from 'react'
import { attributesToProps } from 'html-react-parser'
import classNames from 'classnames'
import { Banner } from './banner-parser-effects'
import type { Parser } from '.'

type BannerType = 'hero' | 'divided' | 'mobile'
export type BannerBlock = {
  [key in BannerType]: string
}

export const bannerParser: Parser = node => {
  if (node.type === 'tag' && typeof node.attribs['data-banner-container'] !== 'undefined') {
    const takeover = node.attribs['data-banner-container'] === 'takeover'
    const showSkeletons = !(node.attribs['data-show-skeletons'] === 'false')
    const props = attributesToProps(node.attribs)

    const bannerBlocks = node.children
      .map(n => {
        if (n.type === 'tag' && typeof n.attribs['data-banner-group'] !== 'undefined') {
          const group: BannerBlock = {
            hero: '',
            divided: '',
            mobile: '',
          }
          n.children.forEach(n => {
            if (
              n.type === 'tag' &&
              typeof n.attribs['data-banner'] !== 'undefined' &&
              typeof n.attribs['data-type'] !== 'undefined'
            ) {
              const type = n.attribs['data-type'] as BannerType
              group[type] = n.attribs['data-banner']
            }
          })
          return group
        } else {
          return null
        }
      })
      .filter(g => g !== null) as BannerBlock[]

    if (!bannerBlocks.length) {
      return null
    }

    const [firstBannerBlock, secondBannerBlock] = bannerBlocks

    return (
      <article
        className={classNames(
          'c-startpage-takeover-wrapper c-box c-box--section u-py-0',
          {
            'u-mb-16': takeover,
          },
          props.className
        )}>
        <div className="container">
          <div className="row">
            {bannerBlocks.length === 1 ? (
              <div
                className={classNames('col-12', {
                  'u-mb-16': !takeover,
                })}>
                {firstBannerBlock && (
                  <Banner block={firstBannerBlock} fullscreen={true} skeletons={showSkeletons} />
                )}
              </div>
            ) : (
              <>
                <div className="col-12 col-lg-6 u-mb-16">
                  {firstBannerBlock && (
                    <Banner block={firstBannerBlock} skeletons={showSkeletons} />
                  )}
                </div>
                <div className="col-12 col-lg-6 u-mb-16">
                  {secondBannerBlock && (
                    <Banner block={secondBannerBlock} skeletons={showSkeletons} />
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </article>
    )
  }
}
